import { useEffect, useLayoutEffect, useRef } from "react"
import { useLocation } from "react-router"

// Keeps route changes from animating. tailwind.css sets
// `html { scroll-behavior: smooth }` for in-page anchor jumps, but React
// Router's <ScrollRestoration> scrolls with plain window.scrollTo() /
// scrollIntoView(), which inherit that value: without this, every client-side
// navigation glides from the old offset across the new page, and Back
// animates to the restored position.
//
// Render this immediately before <ScrollRestoration />. Sibling layout effects
// run in tree order, so when the pathname changes this one forces instant
// scrolling first, ScrollRestoration then scrolls (instantly), and the passive
// effect hands control back to the stylesheet. Same-page hash changes never
// enter the branch, so anchor clicks keep their glide.
export function InstantRouteScroll() {
  const { pathname } = useLocation()
  const previous = useRef(pathname)

  useLayoutEffect(() => {
    if (previous.current === pathname) return
    previous.current = pathname
    document.documentElement.style.scrollBehavior = "auto"
  }, [pathname])

  useEffect(() => {
    if (document.documentElement.style.scrollBehavior) {
      document.documentElement.style.scrollBehavior = ""
    }
  }, [pathname])

  return null
}
